import { daysUntilDue } from './dueDate';
import { getJobRowStyle } from './jobStatusColor';

function enrichScheduleEvent(event) {
  const ref = event.due_date || event.scheduled_date || event.event_date;
  const days =
    ref != null ? daysUntilDue(ref) : event.days_until_due != null ? event.days_until_due : null;
  return {
    ...event,
    days_until_due: days,
    is_urgent: days != null && days >= 0 && days <= 30,
  };
}

/** Issued visit on calendar awaiting worker confirm → violet; confirmed → blue. */
export function scheduleNeedsWorkerAck(event) {
  if (!event) return false;
  const st = String(event.status || event.job_status || '').toUpperCase();
  if (['COMPLETED', 'REJECTED', 'FAILED', 'NOTIFIED'].includes(st)) return false;
  if (event.source === 'mandate' || event.source === 'due' || event.source === 'notify') return false;
  const hasVisit = !!(event.scheduled_date || st === 'SCHEDULED');
  if (!hasVisit) return false;
  if (!event.job_id) return false;
  return !event.schedule_ack_at;
}

export function getScheduleLabel(event) {
  if (event.source === 'mandate') {
    return event.title || 'Mandate';
  }
  if (event.source === 'notify' || event.status === 'NOTIFIED') {
    return event.title || `Notify · ${event.building_name || ''} – ${event.ss_code || ''}`.trim();
  }
  if (event.title) return event.title;
  const parts = [
    event.building_name || '',
    event.ss_name || event.ss_code || '',
    event.assigned_worker_name || event.iqp_name || '',
  ].filter(Boolean);
  return parts.join(' · ') || 'Untitled';
}

export function eventChipClass(event) {
  if (event.source === 'mandate') {
    if (event.event_kind === 'DOCUMENT_REQUEST') return 'bg-amber-100 text-amber-900';
    return 'bg-violet-100 text-violet-900';
  }
  if (event.source === 'notify' || event.status === 'NOTIFIED') {
    return 'bg-sky-100 text-sky-900 border border-sky-200';
  }
  // Shared admin/worker visit: pending confirm = violet, confirmed = blue
  if (scheduleNeedsWorkerAck(event)) {
    return 'bg-violet-100 text-violet-950 border border-violet-300';
  }
  if (
    event.schedule_ack_at &&
    (event.scheduled_date || String(event.status || '').toUpperCase() === 'SCHEDULED')
  ) {
    return 'bg-blue-100 text-blue-900 border border-blue-300';
  }
  if (event.source === 'job' || event.source === 'due' || event.job_id) {
    const style = getJobRowStyle(event.status, event.days_until_due, event.source === 'due');
    return style.badge;
  }
  return 'bg-blue-100 text-blue-800';
}

export function isJobProgressEvent(event) {
  if (!event) return false;
  if (event.source === 'job' || event.source === 'due' || event.source === 'notify') return true;
  return Boolean(event.job_id);
}

export function mergeCalendarEvents(workerSchedules, jobEvents, mandateEvents) {
  const merged = [];
  const seenJobIds = new Set();

  for (const s of workerSchedules || []) {
    const item = enrichScheduleEvent({ ...s, source: s.source || 'schedule' });
    merged.push(item);
    if (item.job_id) seenJobIds.add(item.job_id);
  }

  for (const j of jobEvents || []) {
    if (j.job_id && seenJobIds.has(j.job_id)) continue;
    merged.push(enrichScheduleEvent(j));
    if (j.job_id) seenJobIds.add(j.job_id);
  }

  for (const m of mandateEvents || []) {
    merged.push(m);
  }

  return merged.sort((a, b) => (a.start_time || '').localeCompare(b.start_time || ''));
}
